import { deserialize, identifier, serializable } from "serializr";
import { IJsonObject } from "../api";

interface IProps {
	id?: number;
	amount?: number;
	name?: string;
	description?: string;
}

export class Promo {
	public static fromJson(json: IJsonObject): Promo {
		return deserialize(Promo, json);
	}

	public static fromJsonArray(json: IJsonObject[]): Promo[] {
		return json.map((promo: IJsonObject) => this.fromJson(promo));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public amount: number;

	@serializable
	public name: string;

	@serializable
	public description: string;

	constructor({
		id = 0,
		name = "",
		description = "",
		amount = 0,
	}: IProps = {}) {
		this.id = id;
		this.name = name;
		this.description = description;
		this.amount = amount;
	}
}
